import * as Styles from './styles'

const DescriptionBox = ({ children }) => {
  return <Styles.Container>{children}</Styles.Container>
}

export default DescriptionBox
